import { render, staticRenderFns } from "./UCurricularForm.vue?vue&type=template&id=2358a15b&scoped=true&"
import script from "./UCurricularForm.vue?vue&type=script&lang=js&"
export * from "./UCurricularForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2358a15b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
